import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ResumoRegistroPontoPendente, SituacaoRegistroPendente } from './servico-fila-ponto-local';

@Component({
  selector: 'app-painel-fila-offline',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './painel-fila-offline.component.html'
})
export class PainelFilaOfflineComponent {
  @Input() registros: ResumoRegistroPontoPendente[] = [];
  @Input() totalPendentes = 0;
  @Input() totalFalhas = 0;
  @Input() totalSincronizados = 0;

  get registrosExibidos() {
    return this.registros.slice(0, 5);
  }

  rotuloSituacao(situacao: SituacaoRegistroPendente) {
    if (situacao === 'SINCRONIZADO') {
      return 'Sincronizado';
    }
    if (situacao === 'FALHA') {
      return 'Falha';
    }
    return 'Pendente';
  }

  classeSituacao(situacao: SituacaoRegistroPendente) {
    if (situacao === 'SINCRONIZADO') {
      return 'text-bg-success';
    }
    if (situacao === 'FALHA') {
      return 'text-bg-danger';
    }
    return 'text-bg-warning';
  }
}
